module.exports = __webpack_public_path__ + "static/img/h6.247408a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h6.jpg
// module id = Hatx
// module chunks = 0